import { PART_TYPES } from '../enums'

const data = [
  { subType: PART_TYPES.FACIAL_LINES_CHEEK, title: 'avatar.cheekLines' },
  { subType: PART_TYPES.FACIAL_LINES_CHIN, title: 'avatar.chinLines' },
  { subType: PART_TYPES.FACIAL_LINES_EYES, title: 'avatar.eyeLines' },
  { subType: PART_TYPES.FACIAL_LINES_FOREHEAD, title: 'avatar.foreheadLines' },
]

export default data
